import * as React from "react";
import "./EventHistoryPanel.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { historyEventService } from "../../../../../../modules/multiplayer/peer";
import { EventHistoryUtils } from "../EventHistoryList.util";
import { ChatMessageEditor } from "./chat-message-editor/ChatMessageEditor.component";
import { HistoryEventType } from "../../../../../../messages/scripting/ScriptMessages";
import { ttCloseSidePanelButton, ttConfigButton, ttCopyToClipboardButton, ttLeaveSessionButton, ttSwitchSessionButton } from "../../../../../common-strings.util";
import { useTranslation } from "react-i18next";
export function EventHistoryPanel({ visible, onCloseClicked, onExitClicked, onSwitchSessionClicked, onConfigClicked }) {
    const [history, setHistory] = useState([]);
    const [sessionName, setSessionName] = useState("");
    const { t } = useTranslation();
    const [filter, setFilter] = useState({
        chatMessages: true,
        pictures: true,
        measurements: true,
        userEvents: true,
        modelUploads: true,
        annotations: true,
        recording: true
    });
    useEffect(() => {
        const options = EventHistoryUtils.loadEventHistoryOptions();
        if (options.messageFilter) {
            setFilter(options.messageFilter);
        }
        const onHistoryChanged = () => {
            setHistory([...historyEventService.history]);
        };
        historyEventService.historyChangedDelegate.add(onHistoryChanged);
        const sessionName = localStorage.getItem("session");
        if (sessionName) {
            setSessionName(sessionName);
        }
        return () => {
            historyEventService.historyChangedDelegate.remove(onHistoryChanged);
        };
    }, []);
    useEffect(() => {
        EventHistoryUtils.persistEventHistoryOptions({ messageFilter: filter });
    }, [filter]);
    const createEventHistoryItem = (event, index) => {
        var _a, _b;
        return (React.createElement("div", { className: EventHistoryUtils.getItemClassNames(event.params.clientId, "panel"), key: index },
            React.createElement("div", { className: "event-history-panel-item-header" },
                React.createElement("div", { className: "event-history-panel-item-time" }, (_b = new Date((_a = event.timeReceived) !== null && _a !== void 0 ? _a : 0)) === null || _b === void 0 ? void 0 : _b.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })),
                React.createElement("div", { className: "event-history-panel-item-user" }, EventHistoryUtils.getUsername(event)),
                React.createElement("div", { style: { flexGrow: 1 } }),
                React.createElement("div", { className: "event-history-panel-item-icon", "data-tooltip": EventHistoryUtils.getIconTooltip(event.params.type) },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", EventHistoryUtils.getIconName(event.params.type)] }))),
            React.createElement("div", { className: "event-history-panel-item-content" },
                EventHistoryUtils.createValueElement(event.params),
                EventHistoryUtils.isCopyAllowed(event.params) && event.params.type === HistoryEventType.photo && (React.createElement("button", { className: "icon-button-large event-history-panel-item-copy-button", onClick: () => {
                        EventHistoryUtils.copyToClipboard(event.params);
                    }, "data-tooltip": ttCopyToClipboardButton() },
                    React.createElement(FontAwesomeIcon, { icon: ["fas", "clone"] }))))));
    };
    const getFilteredHistory = () => history.filter((event) => {
        if (event.params.type === HistoryEventType.chatMessage) {
            return filter.chatMessages;
        }
        else if (event.params.type === HistoryEventType.photo) {
            return filter.pictures;
        }
        else if (event.params.type === HistoryEventType.distance || event.params.type === HistoryEventType.moisture) {
            return filter.measurements;
        }
        else if (event.params.type === HistoryEventType.userJoined || event.params.type === HistoryEventType.userLeft) {
            return filter.userEvents;
        }
        else if (event.params.type === HistoryEventType.modelUpload) {
            return filter.modelUploads;
        }
        else if (event.params.type === HistoryEventType.annotation) {
            return filter.annotations;
        }
        else if (event.params.type === HistoryEventType.startRecording || event.params.type === HistoryEventType.stopRecording) {
            return filter.recording;
        }
        return true;
    });
    const createEventHistoryList = () => getFilteredHistory()
        .reverse()
        .map((event, index) => createEventHistoryItem(event, index));
    const createFilterOptions = () => [
        {
            text: t("chatview:filteroption-chat-messages", "Chat messages"),
            checked: filter.chatMessages,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { chatMessages: !filter.chatMessages }));
            }
        },
        {
            text: t("chatview:filteroption-pictures", "Pictures"),
            checked: filter.pictures,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { pictures: !filter.pictures }));
            }
        },
        {
            text: t("chatview:filteroption-measurements", "Measurements"),
            checked: filter.measurements,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { measurements: !filter.measurements }));
            }
        },
        {
            text: t("chatview:filteroption-user-events", "User events"),
            checked: filter.userEvents,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { userEvents: !filter.userEvents }));
            }
        },
        {
            text: t("chatview:filteroption-model-uploads", "Model uploads"),
            checked: filter.modelUploads,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { modelUploads: !filter.modelUploads }));
            }
        },
        {
            text: t("chatview:filteroption-annotations", "Annotations"),
            checked: filter.annotations,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { annotations: !filter.annotations }));
            }
        },
        {
            text: t("chatview:filteroption-recording", "Recording"),
            checked: filter.recording,
            onClick: () => {
                setFilter(Object.assign(Object.assign({}, filter), { recording: !filter.recording }));
            }
        }
    ];
    return (React.createElement("aside", { className: `side-panel-container ${visible ? "event-history-panel-container-visible side-panel-container-visible" : ""}` },
        React.createElement("header", { className: "side-panel-header" },
            React.createElement("button", { className: "icon-button", onClick: onExitClicked, "data-tooltip": ttLeaveSessionButton() },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "door-open"] })),
            React.createElement("button", { className: "icon-button", onClick: onSwitchSessionClicked, "data-tooltip": ttSwitchSessionButton() },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "stream"] })),
            React.createElement("div", { className: "side-panel-header-spacer" }),
            React.createElement("button", { className: "icon-button allow-settings-during-training-dialog", onClick: onConfigClicked, "data-tooltip": ttConfigButton() },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "cog"] })),
            React.createElement("div", { className: "side-panel-header-divider" }),
            React.createElement("button", { className: "icon-button", onClick: onCloseClicked, "data-tooltip": ttCloseSidePanelButton() },
                React.createElement(FontAwesomeIcon, { icon: ["fas", "angle-double-left"] }))),
        sessionName && (React.createElement("header", { className: "side-panel-header side-panel-second-header" },
            React.createElement("h2", null, sessionName))),
        React.createElement("div", { className: "event-history-panel-content" },
            React.createElement("div", { className: "event-history-panel-scroll-container" }, visible && createEventHistoryList())),
        React.createElement("footer", { className: "side-panel-footer event-history-panel-footer" },
            React.createElement(ChatMessageEditor, { visible: visible, filterOptions: createFilterOptions() }))));
}
